(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9794],{

/***/ 77145:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/product/[...slug]",
      function () {
        return __webpack_require__(29537);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.tsx




// next

// @mui

function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        })
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "text.primary",
                "& > div": {
                    display: "inherit"
                }
            },
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.tsx




// @mui

//

function HeaderBreadcrumbs(_param) {
    var links = _param.links, action = _param.action, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "action",
        "heading",
        "moreLink",
        "sx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            mb: 5
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1
                        },
                        children: [
                            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                gutterBottom: true,
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                                links: links
                            }, other))
                        ]
                    }),
                    action && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0
                        },
                        children: action
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    rel: "noopener",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        rel: "noopener",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 27602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LightboxModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92879);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42287);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);







function LightboxModalStyles() {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var isRTL = theme.direction === "rtl";
    var ICON_SIZE = 32;
    var ICON_COLOR = theme.palette.grey[600].replace("#", "");
    var getIcon = function(icon) {
        return "url(https://api.iconify.design/carbon/".concat(icon, ".svg?color=%23").concat(ICON_COLOR, "&width=").concat(ICON_SIZE, "&height=").concat(ICON_SIZE, ")");
    };
    var Icon = function(icon) {
        return {
            opacity: 1,
            alignItems: "center",
            display: "inline-flex",
            justifyContent: "center",
            backgroundImage: "unset",
            backgroundColor: "transparent",
            transition: theme.transitions.create("opacity"),
            "&:before": {
                display: "block",
                width: ICON_SIZE,
                height: ICON_SIZE,
                content: getIcon(icon)
            },
            "&:hover": {
                opacity: 0.72
            }
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        styles: {
            "& .ReactModalPortal": {
                "& .ril__outer": {
                    backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.grey[900], 0.96)
                },
                // Toolbar
                "& .ril__toolbar": {
                    height: "auto !important",
                    padding: theme.spacing(2, 3),
                    backgroundColor: "transparent"
                },
                "& .ril__toolbarLeftSide": {
                    display: "none"
                },
                "& .ril__toolbarRightSide": {
                    height: "auto !important",
                    padding: 0,
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    "& li": {
                        display: "flex",
                        alignItems: "center"
                    },
                    "& li:first-of-type": {
                        flexGrow: 1
                    },
                    "& li:not(:first-of-type)": {
                        width: 40,
                        height: 40,
                        justifyContent: "center",
                        marginLeft: theme.spacing(2)
                    }
                },
                // Button
                "& button:focus": {
                    outline: "none"
                },
                "& .ril__toolbarRightSide button": {
                    width: "100%",
                    height: "100%",
                    "&.ril__zoomInButton": Icon("zoom-in"),
                    "&.ril__zoomOutButton": Icon("zoom-out"),
                    "&.ril__closeButton": Icon("close")
                },
                "& .ril__navButtons": {
                    padding: theme.spacing(3),
                    "&.ril__navButtonPrev": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        right: "auto",
                        left: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-right" : "arrow-left")),
                    "&.ril__navButtonNext": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        left: "auto",
                        right: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-left" : "arrow-right"))
                }
            }
        }
    });
}
function LightboxModal(_param) {
    var images = _param.images, photoIndex = _param.photoIndex, setPhotoIndex = _param.setPhotoIndex, isOpen = _param.isOpen, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "images",
        "photoIndex",
        "setPhotoIndex",
        "isOpen"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isOpen
    ]);
    var showIndex = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        variant: "subtitle2",
        children: "".concat(photoIndex + 1, " / ").concat(images.length)
    });
    var toolbarButtons = [
        showIndex
    ];
    var customStyles = {
        overlay: {
            zIndex: 9999
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LightboxModalStyles, {}),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                animationDuration: 160,
                nextSrc: images[(photoIndex + 1) % images.length],
                prevSrc: images[(photoIndex + images.length - 1) % images.length],
                onMovePrevRequest: function() {
                    return setPhotoIndex((photoIndex + images.length - 1) % images.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIndex((photoIndex + 1) % images.length);
                },
                toolbarButtons: toolbarButtons,
                reactModalStyle: customStyles
            }, other))
        ]
    });
}


/***/ }),

/***/ 59639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Markdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96481);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31192);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50122);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97349);






// markdown plugins

// next

// @mui


//

// ----------------------------------------------------------------------
var MarkdownStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    var isLight = theme.palette.mode === "light";
    var _obj;
    return {
        // p
        "& p": {
            whiteSpace: "pre-line"
        },
        // List
        "& ul, & ol": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, theme.typography.body1), {
            paddingLeft: theme.spacing(2),
            "& li": {
                lineHeight: 2
            }
        }),
        // Blockquote
        "& blockquote": (_obj = {
            lineHeight: 1.5,
            fontSize: "1.5em",
            margin: "40px auto",
            position: "relative",
            fontFamily: "Georgia, serif",
            padding: theme.spacing(3, 3, 3, 8),
            borderRadius: Number(theme.shape.borderRadius) * 2,
            backgroundColor: theme.palette.background.neutral,
            color: "".concat(theme.palette.text.secondary, " !important")
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
            width: "80%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "& p, & span", {
            marginBottom: "0 !important",
            fontSize: "inherit !important",
            fontFamily: "Georgia, serif !important",
            color: "".concat(theme.palette.text.secondary, " !important")
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "&:before", {
            left: 16,
            top: -8,
            display: "block",
            fontSize: "3em",
            content: '"\\201C"',
            position: "absolute",
            color: theme.palette.text.disabled
        }), _obj),
        // Code Block
        "& pre, & pre > code": {
            fontSize: 16,
            overflowX: "auto",
            whiteSpace: "pre",
            padding: theme.spacing(2),
            color: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: isLight ? theme.palette.grey[900] : theme.palette.grey[50016]
        },
        "& code": {
            fontSize: 14,
            borderRadius: 4,
            whiteSpace: "pre",
            padding: theme.spacing(0.2, 0.5),
            color: theme.palette.warning[isLight ? "darker" : "lighter"],
            backgroundColor: theme.palette.warning[isLight ? "lighter" : "darker"],
            "&.hljs": {
                padding: 0,
                backgroundColor: "transparent"
            }
        }
    };
});
// ----------------------------------------------------------------------
function Markdown(_param) {
    var other = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MarkdownStyle, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_8__/* .ReactMarkdown */ .D, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            rehypePlugins: [
                rehype_raw__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
            ],
            components: components
        }, other))
    });
}
// ----------------------------------------------------------------------
var components = {
    h1: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h1"
        }, props));
    },
    h2: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h2"
        }, props));
    },
    h3: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h3"
        }, props));
    },
    h4: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h4"
        }, props));
    },
    h5: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h5"
        }, props));
    },
    h6: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h6"
        }, props));
    },
    hr: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            sx: {
                my: 3
            }
        }, props));
    },
    br: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
            style: {
                display: "block",
                margin: "15px 0",
                content: "''"
            }
        });
    },
    img: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            alt: props.alt,
            ratio: "16/9",
            sx: {
                borderRadius: 2,
                my: 5
            }
        }, props));
    },
    a: function(_param) {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return props.href.includes("http") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            target: "_blank",
            rel: "noopener"
        }, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                children: props.children
            }))
        });
    }
};


/***/ }),

/***/ 23770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cU": function() { return /* reexport */ CarouselArrowIndex; },
  "ZP": function() { return /* binding */ carousel; }
});

// UNUSED EXPORTS: CarouselArrows, CarouselDots

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselDots.tsx
/* eslint-disable react/jsx-no-useless-fragment */ // @mui





var StyledRoot = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "rounded";
    }
})(function(param) {
    var rounded = param.rounded, theme = param.theme;
    return {
        zIndex: 9,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
        "& li": {
            width: 18,
            height: 18,
            opacity: 0.32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            "&.slick-active": (0,src_object_spread/* default */.Z)({
                opacity: 1
            }, rounded && {
                "& span": {
                    width: 16,
                    borderRadius: 6
                }
            })
        }
    };
});
var StyledDot = (0,styled/* default */.ZP)("span")(function(param) {
    var theme = param.theme;
    return {
        width: 8,
        height: 8,
        borderRadius: "50%",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.short
        })
    };
});
function CarouselDots(props) {
    var rounded = (props === null || props === void 0 ? void 0 : props.rounded) || false;
    var sx = props === null || props === void 0 ? void 0 : props.sx;
    return {
        appendDots: function(dots) {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(StyledRoot, _object_spread_props(_object_spread({
                    component: "ul",
                    rounded: rounded,
                    sx: sx
                }, props), {
                    children: dots
                }))
            });
        },
        customPaging: function() {
            return /*#__PURE__*/ _jsx(Stack, {
                component: "div",
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    width: 1,
                    height: 1
                },
                children: /*#__PURE__*/ _jsx(StyledDot, {
                    sx: {
                        bgcolor: "currentColor"
                    }
                })
            });
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
;// CONCATENATED MODULE: ./src/components/carousel/Icon.tsx



function Icon_LeftIcon(param) {
    var _icon = param.icon, icon = _icon === void 0 ? "eva:arrow-ios-forward-fill" : _icon, isRTL = param.isRTL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: icon,
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
}
function Icon_RightIcon(param) {
    var _icon = param.icon, icon = _icon === void 0 ? "eva:arrow-ios-forward-fill" : _icon, isRTL = param.isRTL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: icon,
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrows.tsx
// @mui






//

var StyledIconButton = (0,styled/* default */.ZP)(IconButton/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "filled" && prop !== "hasChildren" && prop !== "shape";
    }
})(function(param) {
    var filled = param.filled, shape = param.shape, hasChildren = param.hasChildren, theme = param.theme;
    return (0,src_object_spread/* default */.Z)({
        color: "inherit",
        transition: theme.transitions.create("all", {
            duration: theme.transitions.duration.shorter
        })
    }, shape === "rounded" && {
        borderRadius: Number(theme.shape.borderRadius) * 1.5
    }, !filled && {
        opacity: 0.48,
        "&:hover": {
            opacity: 1
        }
    }, filled && {
        color: (0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.8),
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48),
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[900]
        }
    }, hasChildren && {
        zIndex: 9,
        top: "50%",
        position: "absolute",
        marginTop: theme.spacing(-2.5)
    });
});
function CarouselArrows(_param) {
    var _shape = _param.shape, shape = _shape === void 0 ? "circular" : _shape, _filled = _param.filled, filled = _filled === void 0 ? false : _filled, icon = _param.icon, onNext = _param.onNext, onPrevious = _param.onPrevious, children = _param.children, leftButtonProps = _param.leftButtonProps, rightButtonProps = _param.rightButtonProps, sx = _param.sx, other = _object_without_properties(_param, [
        "shape",
        "filled",
        "icon",
        "onNext",
        "onPrevious",
        "children",
        "leftButtonProps",
        "rightButtonProps",
        "sx"
    ]);
    var theme = useTheme();
    var isRTL = theme.direction === "rtl";
    var hasChildren = !!children;
    if (hasChildren) {
        return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
            sx: sx
        }, other), {
            children: [
                /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                    filled: filled,
                    shape: shape,
                    hasChildren: !!children,
                    onClick: onPrevious
                }, leftButtonProps), {
                    sx: _object_spread({
                        left: 16
                    }, leftButtonProps === null || leftButtonProps === void 0 ? void 0 : leftButtonProps.sx),
                    children: /*#__PURE__*/ _jsx(LeftIcon, {
                        icon: icon,
                        isRTL: isRTL
                    })
                })),
                children,
                /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                    filled: filled,
                    shape: shape,
                    hasChildren: !!children,
                    onClick: onNext
                }, rightButtonProps), {
                    sx: _object_spread({
                        right: 16
                    }, rightButtonProps === null || rightButtonProps === void 0 ? void 0 : rightButtonProps.sx),
                    children: /*#__PURE__*/ _jsx(RightIcon, {
                        icon: icon,
                        isRTL: isRTL
                    })
                }))
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        direction: "row",
        alignItems: "center",
        display: "inline-flex",
        sx: sx
    }, other), {
        children: [
            /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                filled: filled,
                shape: shape,
                onClick: onPrevious
            }, leftButtonProps), {
                children: /*#__PURE__*/ _jsx(LeftIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            })),
            /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                filled: filled,
                shape: shape,
                onClick: onNext
            }, rightButtonProps), {
                children: /*#__PURE__*/ _jsx(RightIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            }))
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var styles_useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrowIndex.tsx








// ----------------------------------------------------------------------
var CarouselArrowIndex_StyledRoot = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur({
        opacity: 0.48,
        color: theme.palette.grey[900]
    })), {
        zIndex: 9,
        display: "inline-flex",
        alignItems: "center",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        padding: theme.spacing(0.25),
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius
    });
});
var CarouselArrowIndex_StyledIconButton = (0,styled/* default */.ZP)(IconButton/* default */.Z)({
    width: 28,
    height: 28,
    padding: 0,
    opacity: 0.48,
    "&:hover": {
        opacity: 1
    }
});
function CarouselArrowIndex(_param) {
    var index = _param.index, total = _param.total, onNext = _param.onNext, onPrevious = _param.onPrevious, icon = _param.icon, sx = _param.sx, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "index",
        "total",
        "onNext",
        "onPrevious",
        "icon",
        "sx"
    ]);
    var theme = (0,styles_useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselArrowIndex_StyledRoot, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: sx
    }, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_StyledIconButton, {
                color: "inherit",
                onClick: onPrevious,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_LeftIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                component: "span",
                sx: {
                    mx: 0.25
                },
                children: [
                    index + 1,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_StyledIconButton, {
                color: "inherit",
                onClick: onNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_RightIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/carousel/index.ts




/* harmony default export */ var carousel = (lib/* default */.Z);


/***/ }),

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SkeletonImageItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);
// @mui


// ----------------------------------------------------------------------
function SkeletonImageItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 330
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 50,
                            borderRadius: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 150,
                            borderRadius: 1
                        }
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MD": function() { return /* reexport */ SkeletonImage/* default */.Z; },
  "VJ": function() { return /* reexport */ SkeletonPost; },
  "M2": function() { return /* reexport */ SkeletonPostItem; },
  "Ti": function() { return /* reexport */ SkeletonProduct; },
  "JJ": function() { return /* reexport */ SkeletonProductItem; }
});

// UNUSED EXPORTS: SkeletonConversationItem, SkeletonKanbanColumn, SkeletonMailSidebarItem, SkeletonMap

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMap.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonMap() {
    return /*#__PURE__*/ _jsx(Stack, {
        spacing: 8,
        children: _to_consumable_array(Array(5)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                sx: {
                    width: 1,
                    height: 560,
                    borderRadius: 2
                }
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton_Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPost.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPost() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: "100%",
                height: 560,
                variant: "rectangular",
                sx: {
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 3,
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 64,
                        height: 64
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            ml: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProduct.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProduct() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    sx: {
                        paddingTop: "100%",
                        borderRadius: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 240
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPostItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPostItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: 200,
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        sx: {
                            width: 40,
                            height: 40
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            mx: 1,
                            flexGrow: 1
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack_Stack = __webpack_require__(26447);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProductItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProductItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    paddingTop: "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    width: 40
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonKanbanColumn.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonKanbanColumn() {
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            display: "grid",
            gap: 3,
            gridTemplateColumns: "repeat(4, 1fr)"
        },
        children: _to_consumable_array(Array(3)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Paper, {
                variant: "outlined",
                sx: {
                    p: 2.5,
                    width: 310
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "75%",
                                borderRadius: 1.5
                            }
                        }),
                        index === 0 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        }),
                        index !== 2 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        })
                    ]
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMailSidebarItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonMailSidebarItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 32,
                height: 32
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "text",
                sx: {
                    width: 0.25,
                    height: 16
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonConversationItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonConversationItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1.5
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 48,
                height: 48
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 0.5,
                sx: {
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.5,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.25,
                            height: 12
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/skeleton/SkeletonImage.tsx
var SkeletonImage = __webpack_require__(50853);
;// CONCATENATED MODULE: ./src/components/skeleton/index.ts











/***/ }),

/***/ 29537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
// EXTERNAL MODULE: ./src/hooks/useSettings.ts
var useSettings = __webpack_require__(10901);
// EXTERNAL MODULE: ./src/layouts/index.tsx + 45 modules
var layouts = __webpack_require__(72575);
// EXTERNAL MODULE: ./src/components/Page.tsx
var Page = __webpack_require__(61582);
// EXTERNAL MODULE: ./src/components/skeleton/index.ts + 8 modules
var skeleton = __webpack_require__(96339);
// EXTERNAL MODULE: ./src/components/HeaderBreadcrumbs.tsx + 1 modules
var HeaderBreadcrumbs = __webpack_require__(82485);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(20474);
// EXTERNAL MODULE: ./src/hooks/useApp.ts
var useApp = __webpack_require__(28821);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(89419);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(97349);
// EXTERNAL MODULE: ./src/components/LightboxModal.tsx
var LightboxModal = __webpack_require__(27602);
// EXTERNAL MODULE: ./src/components/carousel/index.ts + 4 modules
var carousel = __webpack_require__(23770);
;// CONCATENATED MODULE: ./src/sections/e-commerce/product-details/ProductDetailsCarousel.tsx





// @mui


//



// ----------------------------------------------------------------------
var THUMB_SIZE = 64;
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        "& .slick-slide": {
            float: theme.direction === "rtl" ? "right" : "left",
            "&:focus": {
                outline: "none"
            }
        }
    };
});
function ProductDetailsCarousel(param) {
    var product = param.product;
    var ref = (0,react.useState)(false), openLightbox = ref[0], setOpenLightbox = ref[1];
    var ref1 = (0,react.useState)(0), selectedImage = ref1[0], setSelectedImage = ref1[1];
    var ref2 = (0,react.useState)(0), currentIndex = ref2[0], setCurrentIndex = ref2[1];
    var ref3 = (0,react.useState)(), nav1 = ref3[0], setNav1 = ref3[1];
    var ref4 = (0,react.useState)(), nav2 = ref4[0], setNav2 = ref4[1];
    var slider1 = (0,react.useRef)(null);
    var slider2 = (0,react.useRef)(null);
    var imagesLightbox = product.images.map(function(_image) {
        return _image;
    });
    var handleOpenLightbox = function(url) {
        var selectedImage = imagesLightbox.findIndex(function(index) {
            return index === url;
        });
        setOpenLightbox(true);
        setSelectedImage(selectedImage);
    };
    var settings1 = {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        draggable: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        beforeChange: function(current, next) {
            return setCurrentIndex(next);
        }
    };
    var settings2 = {
        dots: false,
        arrows: false,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        variableWidth: true,
        centerPadding: "0px",
        slidesToShow: product.images.length > 3 ? 3 : product.images.length
    };
    (0,react.useEffect)(function() {
        if (slider1.current) {
            setNav1(slider1.current);
        }
        if (slider2.current) {
            setNav2(slider2.current);
        }
    }, []);
    var handlePrevious = function() {
        var ref;
        (ref = slider2.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
    };
    var handleNext = function() {
        var ref;
        (ref = slider2.current) === null || ref === void 0 ? void 0 : ref.slickNext();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    p: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        zIndex: 0,
                        borderRadius: 2,
                        overflow: "hidden",
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings1), {
                            asNavFor: nav2,
                            ref: slider1,
                            children: product.images.map(function(img) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "large image",
                                    src: img,
                                    ratio: "1/1",
                                    onClick: function() {
                                        return handleOpenLightbox(img);
                                    },
                                    sx: {
                                        cursor: "zoom-in"
                                    }
                                }, img);
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselArrowIndex */.cU, {
                            index: currentIndex,
                            total: product.images.length,
                            onNext: handleNext,
                            onPrevious: handlePrevious
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: (0,_object_spread/* default */.Z)({
                    my: 3,
                    mx: "auto",
                    "& .slick-current .isActive": {
                        opacity: 1
                    }
                }, product.images.length === 1 && {
                    maxWidth: THUMB_SIZE * 1 + 16
                }, product.images.length === 2 && {
                    maxWidth: THUMB_SIZE * 2 + 32
                }, product.images.length === 3 && {
                    maxWidth: THUMB_SIZE * 3 + 48
                }, product.images.length === 4 && {
                    maxWidth: THUMB_SIZE * 3 + 48
                }, product.images.length >= 5 && {
                    maxWidth: THUMB_SIZE * 6
                }, product.images.length > 2 && {
                    position: "relative",
                    "&:before, &:after": {
                        top: 0,
                        zIndex: 9,
                        content: "''",
                        height: "100%",
                        position: "absolute",
                        width: THUMB_SIZE * 2 / 3,
                        backgroundImage: function(theme) {
                            return "linear-gradient(to left, ".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.background.paper, 0), " 0%, ").concat(theme.palette.background.paper, " 100%)");
                        }
                    },
                    "&:after": {
                        right: 0,
                        transform: "scaleX(-1)"
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings2), {
                    asNavFor: nav1,
                    ref: slider2,
                    children: product.images.map(function(img, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                px: 0.75
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                disabledEffect: true,
                                alt: "thumb image",
                                src: img,
                                sx: (0,_object_spread/* default */.Z)({
                                    width: THUMB_SIZE,
                                    height: THUMB_SIZE,
                                    borderRadius: 1.5,
                                    cursor: "pointer"
                                }, currentIndex === index && {
                                    border: function(theme) {
                                        return "solid 3px ".concat(theme.palette.primary.main);
                                    }
                                })
                            })
                        }, img);
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightboxModal/* default */.Z, {
                images: imagesLightbox,
                mainSrc: imagesLightbox[selectedImage],
                photoIndex: selectedImage,
                setPhotoIndex: setSelectedImage,
                isOpen: openLightbox,
                onCloseRequest: function() {
                    return setOpenLightbox(false);
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(99062);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./src/utils/formatNumber.ts
var formatNumber = __webpack_require__(13162);
// EXTERNAL MODULE: ./src/components/Markdown.tsx
var Markdown = __webpack_require__(59639);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/sections/e-commerce/product-details/ProductDetailsSummary.tsx







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    text-decoration: none;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// @mui


// utils

// components



// ----------------------------------------------------------------------
var ProductDetailsSummary_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        height: "100%",
        padding: "".concat(theme.spacing(3), " 0")
    }, theme.breakpoints.up(900), {
        padding: theme.spacing(5, 8),
        paddingRight: 0
    });
});
var StyledLink = (0,styled/* default */.ZP)(Link/* default */.Z)(_templateObject());
function ProductDetailsSummary(_param) {
    var product = _param.product, callToActionLink = _param.callToActionLink, other = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "callToActionLink"
    ]);
    var title = product.title, description = product.description, price = product.price, tags = product.tags;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {} catch (error) {
                    console.error(error);
                }
                return [
                    2
                ];
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailsSummary_RootStyle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                spacing: 1,
                direction: "row",
                sx: {
                    mb: 3
                },
                children: tags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(paths/* PATH_PAGE.products */.ko.products, "?tags=").concat(tag.id, "_").concat(tag.name),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: "".concat(paths/* PATH_PAGE.products */.ko.products, "?tags=").concat(tag.id, "_").concat(tag.name),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: tag.name
                            })
                        })
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                paragraph: true,
                sx: {
                    mb: 3
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    borderStyle: "dashed"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    my: 3,
                    height: {
                        md: "50%",
                        xs: "220px"
                    },
                    overflowY: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                    children: description || ""
                })
            }),
            price && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    mb: 3
                },
                children: [
                    "\xa0",
                    (0,formatNumber/* fCurrency */.e_)(price)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    borderStyle: "dashed"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                fullWidth: true,
                size: "large",
                variant: "contained",
                onClick: callToActionLink ? function() {
                    window.open(callToActionLink.link, "_blank");
                } : onSubmit,
                sx: {
                    whiteSpace: "nowrap",
                    mt: 3
                },
                children: callToActionLink ? callToActionLink.title : "Buy Now"
            })
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./src/components/contentful/Shared.tsx
var Shared = __webpack_require__(41923);
;// CONCATENATED MODULE: ./src/sections/e-commerce/product-details/ProductDetailsContent.tsx



function ProductDetailsContent(param) {
    var content = param.content;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-2xl mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* RichTextStyleWrapper */.w, {
            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content === null || content === void 0 ? void 0 : content.json, (0,Shared/* renderOptionFunc */.Z)(content === null || content === void 0 ? void 0 : (ref = content.links) === null || ref === void 0 ? void 0 : ref.assets))
        })
    });
}

// EXTERNAL MODULE: ./src/sections/e-commerce/shop/index.ts + 6 modules
var shop = __webpack_require__(21340);
;// CONCATENATED MODULE: ./src/sections/e-commerce/product-details/ProductDetailsSimilar.tsx
// @mui


//

function ProductDetailsSimilar(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    mt: 10,
                    mb: 5
                },
                children: "Similar products"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 3,
                children: products.map(function(product) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shop/* ShopProductCard */.a8, {
                            product: product
                        })
                    }, product.id);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/e-commerce/product-details/index.ts





;// CONCATENATED MODULE: ./src/pages/_sites/[appId]/product/[...slug].tsx
// @mui




// routes

// hooks

// layouts

// components








// ----------------------------------------------------------------------
var _slug_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(8)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11)
    });
});
// ----------------------------------------------------------------------
Product.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
// ----------------------------------------------------------------------
function Product(param) {
    var _product = param.product, product = _product === void 0 ? null : _product, _moreProducts = param.moreProducts, moreProducts = _moreProducts === void 0 ? [] : _moreProducts, _seoMetadataItemsCollection = param.seoMetadataItemsCollection, seoMetadataItemsCollection = _seoMetadataItemsCollection === void 0 ? [] : _seoMetadataItemsCollection, _callToActionLink = param.callToActionLink, callToActionLink = _callToActionLink === void 0 ? null : _callToActionLink;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,useApp/* default */.Z)(), logo = ref4.logo, host = ref4.host;
    var locale = (0,router.useRouter)().locale;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: (ref5 = product === null || product === void 0 ? void 0 : product.title) !== null && ref5 !== void 0 ? ref5 : "",
        description: (product === null || product === void 0 ? void 0 : (ref = product.content) === null || ref === void 0 ? void 0 : ref.json) ? (0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)((ref1 = product.content) === null || ref1 === void 0 ? void 0 : ref1.json).slice(250) : undefined,
        metadataItems: seoMetadataItemsCollection,
        openGraphImage: {
            url: (ref7 = (ref6 = product === null || product === void 0 ? void 0 : product.previewUrl) !== null && ref6 !== void 0 ? ref6 : product === null || product === void 0 ? void 0 : product.images[0]) !== null && ref7 !== void 0 ? ref7 : "",
            alt: (ref8 = product === null || product === void 0 ? void 0 : product.title) !== null && ref8 !== void 0 ? ref8 : ""
        },
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "Product",
            name: product === null || product === void 0 ? void 0 : product.title,
            url: "https://".concat(host, "/").concat(locale, "/product/").concat(product === null || product === void 0 ? void 0 : product.slug),
            image: (ref9 = (product === null || product === void 0 ? void 0 : product.previewUrl) || (product === null || product === void 0 ? void 0 : product.images[0]) || logo) !== null && ref9 !== void 0 ? ref9 : "",
            productionDate: (ref10 = product === null || product === void 0 ? void 0 : product.publishedAt) !== null && ref10 !== void 0 ? ref10 : "",
            description: (product === null || product === void 0 ? void 0 : (ref2 = product.content) === null || ref2 === void 0 ? void 0 : ref2.json) ? (0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)((ref3 = product.content) === null || ref3 === void 0 ? void 0 : ref3.json).slice(250) : undefined
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_RootStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: themeStretch ? false : "lg",
                sx: {
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBreadcrumbs/* default */.Z, {
                        links: [
                            {
                                name: "Products",
                                href: paths/* PATH_PAGE.products */.ko.products
                            },
                            {
                                name: (ref11 = product === null || product === void 0 ? void 0 : product.title) !== null && ref11 !== void 0 ? ref11 : ""
                            }, 
                        ].filter(common/* notEmpty */.D)
                    }),
                    product && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsCarousel, {
                                            product: product
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsSummary, {
                                            product: product,
                                            callToActionLink: callToActionLink
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsContent, {
                                    content: product.content
                                })
                            })
                        ]
                    }),
                    !product && /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SkeletonProduct */.Ti, {}),
                    Boolean(moreProducts.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsSimilar, {
                        products: moreProducts
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 20474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ notEmpty; }
/* harmony export */ });
var notEmpty = function(value) {
    return value !== null && value !== undefined;
};


/***/ }),

/***/ 13162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ fNumber; },
/* harmony export */   "e_": function() { return /* binding */ fCurrency; }
/* harmony export */ });
/* unused harmony exports fPercent, fShortenNumber, fData */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// ----------------------------------------------------------------------
function fCurrency(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}
function fPercent(number) {
    return numeral(number / 100).format("0.0%");
}
function fNumber(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format();
}
function fShortenNumber(number) {
    return numeral(number).format("0.00a").replace(".00", "");
}
function fData(number) {
    return numeral(number).format("0.0 b");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,2679,2077,5644,6894,3895,2454,8033,8424,6755,3907,2575,1923,1340,9774,2888,179], function() { return __webpack_exec__(77145); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);